// extracted by mini-css-extract-plugin
export default {"release-info":"fdgKG"};